'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _links;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');
var title = 'Fossil Free Funds';
var description = 'Get your money out of fossil fuels. Fossil Free Funds is a search platform that informs and empowers everyday investors.';
var domain = process.env.DOMAIN || 'https://fossilfreefunds.org';
// if were not the client (window) use the injected config otherwise create it
var Version = require('./data/Version.json');
var FootprintRanges = require('./data/FootprintRanges.json');
var TargetDateSeries = require('./data/TargetDateSeries.json');
var PlanNames = require('./data/PlanNames.json');
var CoreBenchmarks = require('./data/CoreBenchmarks.json');
var ExtendedBenchmarks = require('./data/ExtendedBenchmarks.json');
var FamilyFunds = require('./data/FamilyFunds.json');
var FundCategoryAll = require('./data/FundCategoryAll.json');
var FundFamilyAll = require('./data/FundFamilyAll.json');
var GefScoreNormalizersAllScored = require('./data/GefScoreNormalizersAllScored.json');
var GefScoreNormalizersGroups = require('./data/GefScoreNormalizersGroups.json');
var GefScoreNormalizersPeers = require('./data/GefScoreNormalizersPeers.json');
var CoalPolicyTool = require('./data/CoalPolicyTool.json');
var OilGasPolicyTracker = require('./data/OilGasPolicyTracker.json');
var TspHoldingStats = require('./data/TspHoldingStats.json');
var Changelog = require('./data/Changelog.json');
var config = {
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 3000,
  version: Version['version'],
  description: description,
  domain: domain,
  loggingOff: process.env.LOGGING_OFF,
  httpsRedirect: process.env.HTTPS_REDIRECT,
  gaKey: process.env.GA_KEY,
  apiHost: process.env.APIHOST || 'https://api.fossilfreefunds.org',
  apiPort: process.env.APIPORT || 443,
  imageSocialShare: 'fff-social-share.jpg',
  // for local testing
  // apiHost: 'http://localhost',
  // apiPort: 4000,
  //
  shareMessage: title,
  queryMaxFunds: 10,
  socialAppId: '1094061130685792',
  profilePath: 'fossil-fuel-investments',
  changelog: Changelog,
  gefScoreNormalizers: {
    overall: 22,
    balance: 15,
    policies: 7,
    allScored: GefScoreNormalizersAllScored['all_scored'],
    groups: GefScoreNormalizersGroups,
    peers: GefScoreNormalizersPeers
  },
  routes: {
    home: '/',
    about: '/about',
    howitworks: '/how-it-works',
    videoTutorials: '/video-tutorials',
    fossilFuelCompanies: 'fossil-fuel-companies',
    carbonunderground200: '/carbon-underground-200',
    macroclimate50: '/macroclimate-50',
    morningstar: '/morningstar',
    carbonfootprint: '/carbon-footprint',
    banksInsurance: '/banks-insurance',
    clean200: '/clean-200',
    toolkit: '/fossil-free-action-toolkit',
    media: '/media',
    list: '/funds',
    compare: '/compare',
    clean: '/funds',
    fund: '/fund',
    families: '/families',
    targetdate: '/target-date-funds',
    targetDateFunds: '/target-date-funds',
    tspLanding: '/thrift-savings-plan',
    legal: '/legal',
    resources: '/resources',
    indexfunds: '/index-funds',
    signup: '/sign-up',
    notFound: '/not-found-404',
    tspToolkit: '/thrift-savings-plan-toolkit'
  },
  links: (_links = {
    changelog: 'https://iyv-charts.s3-us-west-2.amazonaws.com/files/',
    blog: 'https://fossilfreefunds.org/blog/',
    fficu200: 'https://www.ffisolutions.com/research-analytics-index-solutions/research-screening/the-carbon-underground-200/',
    macroclimate: 'https://macroclimate.com/about',
    mc50: 'https://macroclimate.com/coal',
    mc50experts: 'http://poll.visionprize.com/#the-1-problem-is-coal',
    globalenergyobservatory: 'http://globalenergyobservatory.org/index.php',
    donate: 'https://connect.clickandpledge.com/w/Form/9d5e83e2-b2d9-43eb-9834-043d7558b785',
    contact: 'https://www.asyousow.org/contact',
    speakout: 'https://go.asyousow.org/take-action-fossil-free-funds',
    signup: 'https://go.asyousow.org/sign-up-fossil-free-funds',
    contactJill: 'mailto:jcourtenay*asyousow.org?subject=Fossil%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send',
    contactCyrus: 'mailto:cnemati*asyousow.org?subject=Fossil%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send',
    contactAndrew: 'mailto:andrew*fossilfreefunds.org?subject=Fossil%20Free%20Funds&body=Replace%20asterisk%20in%20address%20to%20send',
    ays: 'http://www.asyousow.org',
    aysabout: 'http://www.asyousow.org/about-us',
    ceres: 'http://www.ceres.org/investor-network/resolutions#!/subject=&year=&company=&filer=&sector=&status=&memo=&all=&=',
    fff: 'https://fossilfreefunds.org',
    dff: 'https://deforestationfreefunds.org',
    gef: 'https://genderequalityfunds.org',
    wff: 'https://weaponfreefunds.org',
    gff: 'https://gunfreefunds.org',
    tff: 'https://tobaccofreefunds.org',
    pff: 'https://prisonfreefunds.org',
    iyv: 'https://investyourvalues.org',
    iyvPlans: 'https://investyourvalues.org/retirement-plans',
    dffFund: 'https://deforestationfreefunds.org/fund',
    fffFund: 'https://fossilfreefunds.org/funds',
    wffFund: 'https://weaponfreefunds.org/funds',
    pffFund: 'https://prisonfreefunds.org/fund',
    compareFeedback: 'https://forms.gle/cdJG5C7WoGxKkEx78',
    aysinvest: 'https://www.asyousow.org/invest-your-values/',
    proxypreview: 'http://www.proxypreview.org',
    aysvoteshares: 'http://www.asyousow.org/about-us/vote-your-shares/',
    pledge: 'https://www.divestinvestindividual.org/',
    ffi: 'https://www.ffisolutions.com/',
    yoursri: 'https://yoursri.com/',
    spg: 'http://www.thesouthpolegroup.com/',
    issethix: 'https://www.issgovernance.com/esg/iss-ethix/',
    yoursrimethodology: 'https://professional.yoursri.com/media-new/download/appendix-3-carbon-methodology.pdf',
    morningstar: 'https://www.morningstar.com/',
    earthhq: 'https://earthhq.foe.org/defend-the-rainforest',
    friends: 'http://www.foe.org/',
    foemain: 'http://www.foe.org/DeforestationFreeAction',
    foeabout: 'http://www.foe.org/about-us/friends-of-the-earth-international',
    foereport: 'http://webiva-downton.s3.amazonaws.com/877/72/7/8646/Invested_in_Exploitation.Digital.compressed.pdf',
    profundo: 'http://www.profundo.nl',
    ran: 'http://www.ran.org/sf20scorecard',
    uocs: 'http://www.ucsusa.org/global-warming/stop-deforestation/palm-oil-scorecard-2015#.V358U_krLGg',
    zoolondon: 'http://www.sustainablepalmoil.org/companies/',
    supplychange: 'http://www.supply-change.org/commodity/palm',
    greenpeace: 'http://www.greenpeace.org/usa/palm-oil-scorecard-are-brands-doing-enough-for-indonesias-rainforests/'
  }, (0, _defineProperty3.default)(_links, 'dffFund', 'https://www.deforestationfreefunds.org/funds'), (0, _defineProperty3.default)(_links, 'clean200', 'https://www.asyousow.org/clean200'), (0, _defineProperty3.default)(_links, 'clean200Methodology', 'https://www.clean200.org/methodology/'), (0, _defineProperty3.default)(_links, 'whitePaper', 'https://www.asyousow.org/ays_report/aligning-defined-contribution-plans-with-corporate-sustainability-goals/'), (0, _defineProperty3.default)(_links, 'socialFFFfb', 'https://www.facebook.com/FossilFreeFunds/'), (0, _defineProperty3.default)(_links, 'socialFFFtwitter', 'https://twitter.com/FossilFreeFunds'), (0, _defineProperty3.default)(_links, 'socialAYSfb', 'https://www.facebook.com/asyousow.org/'), (0, _defineProperty3.default)(_links, 'socialAYStwitter', 'https://twitter.com/asyousow'), (0, _defineProperty3.default)(_links, 'socialAYSinstagram', 'https://www.instagram.com/_asyousow_/'), (0, _defineProperty3.default)(_links, 'nytHome', 'https://www.nytimes.com/2017/10/13/business/mutfund/mutual-funds-low-carbon.html'), (0, _defineProperty3.default)(_links, 'bloombergHome', 'https://www.bna.com/ge-microsoft-urged-n57982069981/'), (0, _defineProperty3.default)(_links, 'guardianHome', 'https://www.theguardian.com/sustainable-business/2016/oct/27/investment-advice-retirement-portfolio-tips-climate-change-financial-risk'), (0, _defineProperty3.default)(_links, 'fastcompanyHome', 'https://www.fastcompany.com/3059618/how-to-convince-your-employer-to-divest-your-401k-from-fossil-fuels'), (0, _defineProperty3.default)(_links, 'thinkprogressHome', 'https://thinkprogress.org/theres-now-a-way-to-find-out-how-much-of-your-retirement-is-invested-in-fossil-fuels-5f63efa9e784/'), (0, _defineProperty3.default)(_links, 'ussifperf', 'https://www.ussif.org/performance'), (0, _defineProperty3.default)(_links, 'ussif', 'https://www.ussif.org/'), (0, _defineProperty3.default)(_links, 'gcel', 'https://coalexit.org/'), (0, _defineProperty3.default)(_links, 'gogel', 'https://gogel.org/'), _links),
  // for recent blog posts component
  blog: [{
    url: '2025/04/05/humanitarian-impacts-investment-risks-conventional-weapons.html',
    image: '/blog/assets/img/post-thumbnails/weapon-ploughshares-3-thumbnail.png',
    title: 'The Humanitarian Impacts and Investment Risks of Conventional Weapons ',
    subtitle: "Conventional weapons cause immense human suffering, particularly when they are used with excessive force or indiscriminately against civilians, in violation of international human rights law.",
    date: '2025-04-05'
  }, {
    url: '2025/03/12/ethical-financial-risks-investing-controversial-weapons.html',
    image: '/blog/assets/img/post-thumbnails/weapon-ploughshares-2-thumbnail.png',
    title: 'The Ethical and Financial Risks of Investing in Controversial Weapons',
    subtitle: "Many military weapons are considered controversial weapons due to the indiscriminate harm they cause to civilians, violating international humanitarian principles. Investing in controversial weapons makers doesn’t just threaten global peace – it also threatens your savings.",
    date: '2025-03-12'
  }, {
    url: '2025/02/06/university-retirement-plans-funding-destruction-students-future.html',
    image: '/blog/assets/img/post-thumbnails/university-annuities-thumbnail.jpg',
    title: 'University Retirement Plans are Funding the Destruction of their Students’ Future',
    subtitle: "We analyzed 10 defined contribution plans offered by five large universities: Columbia, Harvard, Northwestern, Princeton, and Notre Dame. We found that billions of dollars in university employee retirement savings are invested in companies with significant environmental and social risks.",
    date: '2025-02-06'
  }, {
    url: '2025/02/04/you-might-be-invested-in-military-weapon-manufacturers.html',
    image: '/blog/assets/img/post-thumbnails/weapon-ploughshares-1-thumbnail.png',
    title: 'You Might be Invested in Military Weapon Manufacturers',
    subtitle: "What if I told you your hard-earned retirement savings are likely invested in companies that manufacture weapons of war?",
    date: '2025-02-04'
  }, {
    url: '2024/11/12/how-google-found-fossil-free-fund-401k.html',
    image: '/blog/assets/img/post-thumbnails/google-fossil-free-thumbnail.jpg',
    title: 'How Google found a fossil free fund for their 401(k) ',
    subtitle: "Many U.S. employees saving for retirement are invested in companies fueling the climate crisis, exposing their savings to climate-related financial risk. Employees are increasingly calling for climate-safe fund options to avoid these risks.",
    date: '2024-11-12'
  }, {
    url: '2024/08/27/what-to-do-bank-financing-climate-crisis.html',
    image: '/blog/assets/img/post-thumbnails/green-banks-thumbnail.jpg',
    title: 'What to do if your bank is financing the climate crisis',
    subtitle: "Despite clear evidence and global consensus of the need to shift away from fossil fuels because of climate change, the fossil fuel industry continues to expand production and roll back environmental commitments. This expansion is facilitated by financing from the world’s largest banks.",
    date: '2024-08-27'
  }],
  // for email capture sign up forms
  signupForm: {
    url: 'https://go.asyousow.org/l/344561/2017-05-15/4zx',
    id: '344561_1307pi_344561_1307'
  },
  // for get started component driving people to "Clean" lists
  getStartedInput: {
    label: 'Top-rated funds',
    title: 'Top-rated funds | Fossil Free Funds',
    faclass: 'fa-angle-double-right'
  },
  // footprint date IF NEEDED
  footprintDate: 'Nov. 2020',
  // for footprint scoring
  footprintRanges: FootprintRanges,
  // core and extended benchmarks for footprint charts and returns comparisons
  coreBenchmarks: CoreBenchmarks,
  extendedBenchmarks: ExtendedBenchmarks,
  // asset managers for Family view
  familyFunds: FamilyFunds,
  // target dates
  targetDateSeries: TargetDateSeries,
  // Plans to link out to IYV-APP
  planNames: PlanNames,
  // for fossil finance popups
  coalPolicyTool: CoalPolicyTool,
  oilGasPolicyTracker: OilGasPolicyTracker,
  // for TSP landing page
  tspHoldingStats: TspHoldingStats,
  // NOT NEEDED (used in DFF)
  engagementFunds: [],
  /*ignore jslint start*/
  formOptions: {
    market: [{ name: 'All funds', value: 'Show all funds' }, { name: 'United States', value: 'US' }],
    type: [{ name: 'All funds', value: 'All funds' }, { name: 'Open-end funds', value: 'FO' }, { name: 'Exchange-traded funds (ETFs)', value: 'FE' }, { name: 'Common/Collective trusts', value: 'TSP' }, { name: 'Variable annuities', value: 'VA' }],
    diversified: [{ name: 'All funds', value: false }, { name: 'Diversified', value: 'false' }, { name: 'Non-diversified', value: 'true' }],
    sri: [{ name: 'All funds', value: false }, { name: 'Sustainability mandate', value: '1' }],
    fundUssif: [{ name: 'All funds', value: false }, { name: 'US-SIF funds', value: '1.5' }],
    targetDate: [{ name: 'All funds', value: false }, { name: 'Target date funds', value: '1' }],
    fundPerformance: [{ name: 'All funds', value: false }, { name: 'Positive 1-year returns', value: 'trailing_return_y1' }, { name: 'Positive 3-year returns', value: 'trailing_return_y3' }, { name: 'Positive 5-year returns', value: 'trailing_return_y5' }, { name: 'Positive 10-year returns', value: 'trailing_return_y10' }, { name: 'Positive 15-year returns', value: 'trailing_return_y15' }, { name: 'Positive 20-year returns', value: 'trailing_return_y20' }],
    fffGrade: [{ name: 'All funds', value: false }, { name: 'Fossil fuel grade A', value: 1 }, { name: 'Fossil fuel grade B or higher', value: 2 }, { name: 'Fossil fuel grade C or higher', value: 3 }, { name: 'Fossil fuel grade D or higher', value: 4 }],
    ffbGrade: [{ name: 'All funds', value: false }, { name: 'Fossil finance grade A', value: 1 }, { name: 'Fossil finance grade B or higher', value: 2 }, { name: 'Fossil finance grade C or higher', value: 3 }, { name: 'Fossil finance grade D or higher', value: 4 }],
    ffiGrade: [{ name: 'All funds', value: false }, { name: 'Fossil insurance grade A', value: 1 }, { name: 'Fossil insurance grade B or higher', value: 2 }, { name: 'Fossil insurance grade C or higher', value: 3 }, { name: 'Fossil insurance grade D or higher', value: 4 }],
    dffGrade: [{ name: 'All funds', value: false }, { name: 'Deforestation grade A', value: 1 }, { name: 'Deforestation grade Engagement or higher', value: 1.5 }, { name: 'Deforestation grade B or higher', value: 2 }, { name: 'Deforestation grade C or higher', value: 3 }, { name: 'Deforestation grade D or higher', value: 4 }],
    gefGrade: [{ name: 'All funds', value: false }, { name: 'Gender equality grade A', value: 1 }, { name: 'Gender equality grade B or higher', value: 2 }, { name: 'Gender equality grade C or higher', value: 3 }, { name: 'Gender equality grade D or higher', value: 4 }],
    wffGrade: [{ name: 'All funds', value: false }, { name: 'Weapon grade A', value: 1 }, { name: 'Weapon grade B or higher', value: 2 }, { name: 'Weapon grade C or higher', value: 3 }, { name: 'Weapon grade D or higher', value: 4 }],
    gffGrade: [{ name: 'All funds', value: false }, { name: 'Civilian firearm grade A', value: 1 }, { name: 'Civilian firearm grade B or higher', value: 2 }, { name: 'Civilian firearm grade C or higher', value: 3 }, { name: 'Civilian firearm grade D or higher', value: 4 }],
    tffGrade: [{ name: 'All funds', value: false }, { name: 'Tobacco grade A', value: 1 }, { name: 'Tobacco grade Engagement or higher', value: 1.5 }, { name: 'Tobacco grade B or higher', value: 2 }, { name: 'Tobacco grade C or higher', value: 3 }, { name: 'Tobacco grade D or higher', value: 4 }],
    pffGrade: [{ name: 'All funds', value: false }, { name: 'Prison industrial complex grade A', value: 1 }, { name: 'Prison industrial complex grade B or higher', value: 2 }, { name: 'Prison industrial complex grade C or higher', value: 3 }, { name: 'Prison industrial complex grade D or higher', value: 4 }],
    clean: [{ name: 'All funds', value: false }, { name: 'A grade funds only', value: 'true' }],
    currency: [],
    currencyAll: [{ name: 'All funds' }, { name: 'US Dollar' }],
    currencyUS: [],
    currencyUK: [],
    currencyHK: [],
    currencyDK: [],
    currencyFR: [],
    currencyDE: [],
    fundGroup: [],
    fundGroupAll: [{ name: 'All funds' }, { name: 'Allocation Funds' }, { name: 'International Equity Funds' }, { name: 'Sector Equity Funds' }, { name: 'U.S. Equity Fund' }],
    fundGroupUS: [],
    fundGroupUK: [],
    fundGroupHK: [],
    fundGroupDK: [],
    fundGroupFR: [],
    fundGroupDE: [],
    fundCategory: [],
    fundCategoryAll: FundCategoryAll,
    fundCategoryUS: [],
    fundCategoryUK: [],
    fundCategoryHK: [],
    fundCategoryDK: [],
    fundCategoryFR: [],
    fundCategoryDE: [],
    fundFamily: [],
    fundFamilyAll: FundFamilyAll,
    fundFamilyUS: [],
    fundFamilyUK: [],
    fundFamilyHK: [],
    fundFamilyDK: [],
    fundFamilyFR: [],
    fundFamilyDE: []
  },
  /*ignore jslint end*/

  app: {
    title: title,
    description: description,
    head: {
      defaultTitle: title,
      titleTemplate: '%s | ' + title,
      meta: [{ name: 'description', content: description }, { charset: 'utf-8' },
      // twitter
      { property: 'twitter:card', content: 'summary_large_image' }, { property: 'twitter:site', content: '@fossilfreefunds' }, { property: 'twitter:title', content: title }, { property: 'twitter:description', content: description }, { property: 'twitter:creator', content: '@fossilfreefunds' }, { property: 'twitter:image', content: '' },
      // {property: 'twitter:image', content: ''},

      // og
      { property: 'og:site_name', content: title }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: domain }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'og:image', content: '' }]
    }
  }
};
// inject the serverconfig if its on the browser
if (typeof window !== 'undefined') {
  config = (0, _assign2.default)({}, config, window.__serverConfig);
}
module.exports = config;


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 11
// module chunks = 0